import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'piqet-angular-new-project-inline-dropdown',
  templateUrl: './new-project-inline-dropdown.component.html',
  styleUrls: ['./new-project-inline-dropdown.component.css'],
})
export class NewProjectInlineDropdownComponent {
  conversionRegion: any;
  params: any;
  countryId: any;
  isClearable: boolean = true;
  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.conversionRegion = this.params.conversionRegion;
    this.countryId = this.params.data.conversionCountryId;

    if (this.params?.type == 'packMatrialConversion') {
      this.isClearable = false;
    }
  }
  commonInputSearchForCountry(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
  updateValue(id: any) {
    this.params.data = cloneDeep(this.params.data);
    this.params.data.conversionCountryId = id;
    this.params.editData(this.params.data);
  }
}
